import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { CaptureResolverService } from '../services/capture-resolver.service';
import { CaptureService } from '../services/Capture.service';

@Injectable({
  providedIn: 'root'
})
export class CaptureResolverGuard implements Resolve<Observable<any>> {
  constructor(
    //private captureResolverService: CaptureResolverService
    private captureService: CaptureService
  ) { }
  // canActivate(
  //   route: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  //   return true;
  // }
  resolve(route: ActivatedRouteSnapshot) {
    return this.captureService.getCapture();
  }

}
